import type { SelectChangeEvent } from '@mui/material/Select';

import { memo } from 'react';

import Stack from '@mui/material/Stack';
import { MenuItem } from '@mui/material';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';

import { KNOWLEDGE_BASES } from 'src/utils/constants';

import { StyledSettingsLabel } from './SettingsView';
import { useSettingsContext } from '../hooks/useSettingsContext';
import { useGetKnowledgeBases } from '../hooks/useGetKnowledgeBases';
import { useChatHistoryContext } from '../hooks/useChatHistoryContext';

const SettingsKnowledgeBaseSelect = memo(function SettingsKnowledgeBaseSelect() {
  const { settings, setSettings } = useSettingsContext();
  const { allFiles } = useChatHistoryContext();
  const { knowledgeBases } = useGetKnowledgeBases();

  const allKnowledgeBases = [...knowledgeBases, ...KNOWLEDGE_BASES];

  const isChecked = (id: string) => settings.knowledgeBase?.includes(id);

  const handleSelectChange = (event: SelectChangeEvent<string[]>) => {
    const selectedIds: string[] = event.target.value as string[];

    const getKnowledgeBaseType = () => {
      if (settings.knowledgeBase?.length === 0 && selectedIds.length > 0) {
        const matched = allKnowledgeBases.find((eachItem) => eachItem.id === selectedIds[0]);
        return matched?.metadata?.provider ?? '';
      } else if (selectedIds.length === 0) {
        return '';
      }
      return settings.knowledgeBaseType;
    };

    setSettings((prev) => ({
      ...prev,
      knowledgeBase: selectedIds,
      knowledgeBaseType: getKnowledgeBaseType().toLowerCase(),
    }));
  };

  return (
    <Stack gap={1}>
      <StyledSettingsLabel>Knowledge Bases</StyledSettingsLabel>
      <Select
        size="small"
        multiple
        value={settings.knowledgeBase || []}
        disabled={Boolean(allFiles.filter((eachItem) => !!eachItem.id).length)}
        onChange={handleSelectChange}
        renderValue={(selected) =>
          selected.map((id) => allKnowledgeBases.find((kb) => kb.id === id)?.name).join(', ')
        }
      >
        {allKnowledgeBases.map((kb) => {
          const isDisabled =
            !!settings.knowledgeBaseType &&
            settings.knowledgeBaseType !== kb.metadata?.provider.toLowerCase();

          return (
            <MenuItem key={kb.id} value={kb.id} disabled={isDisabled}>
              <Checkbox checked={isChecked(kb.id)} disabled={isDisabled} />
              <ListItemText primary={kb.name} />
            </MenuItem>
          );
        })}
      </Select>
    </Stack>
  );
});

export default SettingsKnowledgeBaseSelect;
